import { Breakpoint, Button } from '@elearning-platform/ui';
import { styled } from 'styled-components';

export const ResultWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;

  @media ${Breakpoint.SmallDesktop} {
    flex-direction: row;
  }
`;

export const ResultContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

export const ResultQuestionsContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  padding-top: 24px;
`;

export const ResultImageContainer = styled.div`
  display: flex;
  align-items: flex-end;
  justify-content: flex-end;
  padding-bottom: 16px;

  @media ${Breakpoint.SmallDesktop} {
    padding-bottom: 0;
  }
`;

export const ResultImage = styled.img`
  width: 100%;
  @media ${Breakpoint.SmallDesktop} {
    width: auto;
  }
`;

export const FeedbackContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
  padding-top: 24px;

  @media ${Breakpoint.SmallDesktop} {
    gap: 40px;
    padding-top: 40px;
  }
`;

export const StyledButton = styled(Button)`
  align-self: baseline;
`;
